import axios from "axios";

const endpoint_url = "/message/options/products";

const getProducts = ({ node_uuids, name, orderBy, sort, length, start }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          length,
          start,
          sort,
          orderBy,
          name,
          node_uuids
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getProducts;
